import { render, staticRenderFns } from "./Offline.vue?vue&type=template&id=2b440853"
import script from "./Offline.vue?vue&type=script&lang=js"
export * from "./Offline.vue?vue&type=script&lang=js"
import style0 from "./Offline.vue?vue&type=style&index=0&id=2b440853&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports